import styles from '@pages/RequirementLaborResources/RequirementLaborResources.module.scss'
import React from 'react'

export const Badge = ({
								 value,
								 label,
							 }) => {
	return (
		<div className={styles.badge}>
			<p className={styles.badge__value}>
				{value}
			</p>
			<p className={styles.badge__label}>
				{label}
			</p>
		</div>
	)
}